import { css, cx } from "@emotion/css";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import type { MouseEvent } from "react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SettingsIcon from "src/images/Icons/newIcons/settings.svg";

import isMobile from "../../../helpers/isMobile";
import { IconButton } from "../../Default/LekUI/Button";
import { SwipeableContent } from "../../Default/LekUI/SwipableDrawer";
import { Tooltip } from "../../Default/LekUI/Tooltip";
import Popper from "../../NewComponents/Default/Popper";
import { SettingsContainer } from "./SettingsContainer";

export const Settings = () => {
	const { t } = useTranslation();
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

	useEffect(() => {
		setAnchorEl(null);
	}, []);

	const onStatsClick = (e: MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(e.currentTarget);
	};

	const close = () => {
		setAnchorEl(null);
	};

	const renderContent = () => {
		if (isMobile()) {
			return (
				<SwipeableContent isOpen={!!anchorEl} onClose={close}>
					<div className="ofy-auto">{!!anchorEl && <SettingsContainer />}</div>
				</SwipeableContent>
			);
		}

		return (
			<Popper className="" anchorEl={anchorEl}>
				<ClickAwayListener onClickAway={close}>
					<div
						className={cx(
							"popper of-auto",
							css`
                max-height: 400px;
              `,
						)}
					>
						<SettingsContainer />
					</div>
				</ClickAwayListener>
			</Popper>
		);
	};

	return (
		<>
			<Tooltip title={t("tooltips.settings")}>
				<IconButton isActive={!!anchorEl} onClick={onStatsClick}>
					<SettingsIcon className="icon-big" />
				</IconButton>
			</Tooltip>
			{renderContent()}
		</>
	);
};
